import * as React from "react";
import { IconProps } from "./types";

export const Asterisk02Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M12 4V20M18 6L6 18M20 12H4M18 18L6 6"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(Asterisk02Icon as React.FunctionComponent).displayName = "Asterisk02Icon";

export default Asterisk02Icon;
